export const translations = {
  en: {
    brand: "Social Gallery",
    tagline: "A quiet room for photographers.",
    lead:
      "A curated feed for photographic work. No noise. No filters. Just frames that earn attention.",
    global_feed: "Global Feed",
    explore: "Explore",
    sign_in: "Sign in",
    sign_up: "Sign up",
    sign_out: "Sign out",
    upload: "Upload",
    my_profile: "My profile",
    email: "Email",
    password: "Password",
    name: "Display name",
    create_account: "Create account",
    already_have: "Already have an account?",
    no_account: "New to Social Gallery?",
    by_artist: "By",
    appreciate: "Appreciate",
    appreciated: "Appreciated",
    comments: "Comments",
    critique: "Technical Critique",
    write_comment: "Share your thoughts…",
    write_critique: "Offer a technical critique — light, composition, gear…",
    post: "Post",
    back_to_feed: "Back to feed",
    shot_details: "Shot Details",
    camera: "Camera",
    lens: "Lens",
    iso: "ISO",
    aperture: "Aperture",
    shutter: "Shutter",
    focal_length: "Focal Length",
    date_taken: "Date",
    resolution: "Resolution",
    no_exif: "No EXIF data available for this frame.",
    upload_title: "Upload a new frame",
    upload_desc:
      "Upload a single high-resolution photograph. EXIF data will be read automatically.",
    file: "File",
    photo_title: "Title",
    photo_description: "Description",
    submit: "Publish",
    uploading: "Publishing…",
    profile: "Profile",
    about: "About",
    works: "Works",
    no_photos_yet: "No photographs yet.",
    edit_profile: "Edit profile",
    save: "Save",
    cancel: "Cancel",
    bio: "Biography",
    avatar_url: "Avatar URL",
    login_title: "Welcome back.",
    register_title: "Join the gallery.",
    share: "Share",
    share_copied: "Share link copied to clipboard.",
    featured: "Pick of the Week",
    pick_of_week: "Pick of the Week",
    pin_as_pick: "Pin as Pick of the Week",
    pinned: "Pinned as Pick",
    follow: "Follow",
    following: "Following",
    followers_label: "Followers",
    search_placeholder: "Search camera or lens…",
    no_results: "No frames match this camera.",
    hero_eyebrow: "Est. 2026 — A photography society",
    explore_feed: "Explore the feed",
    join: "Become a member",
    loading: "Loading…",
    frames: "frames",
    followers: "followers",
    members: "Members",
    upgrade: "Upgrade",
    upgrade_title: "Join the Portfolio circle.",
    upgrade_lead: "Unlock a verified badge, a custom /p/{slug} portfolio page, and unlimited upload resolution. One payment, forever.",
    portfolio_tier: "Portfolio — lifetime",
    price: "$4.99",
    price_note: "one-time payment",
    feature_verified: "Verified red-dot next to your name on every frame",
    feature_portfolio: "Custom portfolio URL: /p/your-name",
    feature_resolution: "Unlimited upload resolution",
    feature_support: "Support the gallery",
    upgrade_cta: "Upgrade now",
    already_premium: "You're already a Portfolio member. ✦",
    upgrade_cancelled: "Upgrade cancelled — you have not been charged.",
    paying: "Redirecting to secure checkout…",
    payment_success_title: "Welcome to Portfolio.",
    payment_success_body: "Your verified badge is live and your portfolio page is ready.",
    go_to_portfolio: "View my portfolio",
    payment_failed: "Payment did not complete. Please try again from the Upgrade page.",
    checking_payment: "Confirming your payment…",
    verified: "Verified",
    critique_composition: "Composition",
    critique_exposure: "Exposure & Light",
    critique_processing: "Post-processing",
    critique_rate: "Rate",
    critique_notes: "Notes — light, framing, gear, intent…",
    critique_rating_summary: "Rating",
    hubs: "Gear",
    hubs_eyebrow: "Curated · By gear",
    hubs_eyebrow_detail: "Gear hub",
    hubs_title: "Frames by gear",
    hubs_lead:
      "Explore the feed through the lens of a specific body. Every camera model used on Social Gallery gets its own curated page.",
    hubs_empty: "No gear hubs yet — be the first to upload a frame with EXIF.",
    frame: "frame",
    share_to: "Share to",
    copy_link: "Copy link",
    share_copy_failed: "Could not copy link.",
    share_instagram_hint: "Link copied — paste it into Instagram.",
    forgot_password_link: "Forgot password?",
    forgot_title: "Forgot your password?",
    forgot_lead: "Enter the email you signed up with. If we find it, we'll send you a link to choose a new password.",
    forgot_submit: "Send reset link",
    forgot_sent: "Check your inbox. If an account exists for that email, a reset link is on its way. The link expires in 60 minutes.",
    reset_title: "Choose a new password.",
    reset_lead: "Make it at least 6 characters. You'll be signed in automatically once it's set.",
    reset_new_password: "New password",
    reset_confirm_password: "Confirm password",
    reset_submit: "Reset password",
    reset_invalid_title: "Reset link looks invalid.",
    reset_invalid_body: "This password reset link is missing, expired, or has already been used. Request a new one below.",
    password_too_short: "Password must be at least 6 characters.",
    password_mismatch: "Passwords don't match.",
    darkroom_mode: "Darkroom",
    darkroom_exit: "Exit Darkroom",
    darkroom_hint: "Full-screen viewer · press Esc to exit",
    darkroom_hide_exif: "Hide details",
    darkroom_show_exif: "Show details",
    backdrop_dark: "Dark backdrop",
    backdrop_grey: "Grey backdrop",
    backdrop_light: "Light backdrop",
    dominant_color: "Dominant color",
    hint_click_to_search: "Click any field to find similar frames",
    filtered_feed: "Filtered feed",
    clear_all: "Clear all",
    tip_iso: "ISO measures the sensor's sensitivity to light. Lower is cleaner; higher lets you shoot in low light but adds grain.",
    tip_aperture: "Aperture (f-number) controls depth of field. Lower numbers blur the background; higher numbers keep more in focus.",
    tip_shutter: "Shutter speed sets how long the sensor sees light. Short freezes motion; long blurs it or lets in more light.",
    tip_focal_length: "Focal length is the zoom. Short = wide view; long = telephoto, compresses distance.",
    tip_lens: "The lens that made the picture. Click to see other frames captured with the same glass.",
    partner_eyebrow: "Featured Partner · Scan to visit",
    partner_title: "DSLR Advisor — Sign in",
    welcome_eyebrow: "A note from the curator",
    welcome_title: "Welcome to Social Gallery.",
    welcome_p1: "A dedicated space for the art of photography — created for photographers of all skill levels to share their work, engage in technical critique, and explore the craft without the noise of traditional social media.",
    welcome_p2: "Whether you are a student mastering manual settings or a seasoned enthusiast, Social Gallery provides a clean environment to showcase your vision and learn from the community.",
    welcome_p3: "I hope you find this space helpful in your creative journey. Your feedback is essential as we continue to refine this platform. If you have thoughts to share or need assistance, feel free to reach out.",
    contact_eyebrow: "Get in touch",
    views: "views",
    shares: "shares",
    stats_views: "Views",
    stats_shares: "Shares",
    photo_stats: "Reach",
    notifications: "Notifications",
    edit_photo: "Edit photo",
    edit_photo_title: "Edit your photograph",
    edit_section_details: "Details",
    edit_section_exif: "Shot details",
    edit_section_replace: "Replace image",
    edit_save: "Save changes",
    edit_saving: "Saving…",
    edit_replace_lead: "Upload a new version of this image. Your views, appreciations, and comments stay.",
    edit_fix_orientation: "Fix rotation",
    edit_fixing_orientation: "Fixing rotation…",
    edit_fix_orientation_hint: "Re-generates the preview using your photo's orientation tag. Use this if the thumbnail appears sideways.",
    edit_orientation_fixed: "Rotation fixed.",
    refresh_all_thumbnails: "Fix rotation on all my photos",
    refreshing_all: "Refreshing thumbnails…",
    refresh_all_done: "Fixed {fixed} of {total} photos.",
    tools_organize: "Organize genres",
    tools_duplicates: "Find duplicates",
    tools_eyebrow: "Library tools",
    bc_title: "Bulk categorize",
    bc_sub: "Every photo of yours without a genre, in one place. AI suggestions are pre-selected. Confirm, change or clear them, then save.",
    bc_suggesting: "AI is looking…",
    bc_ai_badge: "AI pick",
    bc_no_suggestion: "No AI suggestion. Pick one.",
    bc_save: "Save {n} photos",
    bc_saved: "Saved genres for {n} photos.",
    bc_empty: "Every one of your photos has a genre.",
    dup_title: "Duplicate cleanup",
    dup_sub: "Finds uploads that are the exact same file. The oldest copy in each group is kept by default.",
    dup_scope_mine: "My photos",
    dup_scope_all: "Everyone (admin)",
    dup_scanning: "Scanning… the first scan can take up to a minute.",
    dup_none: "No duplicates found in {n} photos.",
    dup_group: "{n} copies",
    dup_keep: "Keep",
    dup_delete_mark: "Delete",
    dup_delete_selected: "Delete {n} selected",
    dup_confirm_title: "Delete {n} photos?",
    dup_confirm_body: "This permanently removes the selected photos along with their appreciations and comments. It can't be undone.",
    dup_cancel: "Cancel",
    dup_deleted: "Deleted {n} photos.",
    dup_uploaded: "Uploaded",
    email_did_you_mean: "Did you mean",
    bc_save_one: "Save 1 photo",
    bc_saved_one: "Saved the genre for 1 photo.",
    dup_delete_selected_one: "Delete 1 selected",
    dup_confirm_title_one: "Delete 1 photo?",
    dup_deleted_one: "Deleted 1 photo.",
    dup_none_one: "No duplicates found in 1 photo.",
    edit_replace_file: "Choose new file",
    edit_replace_reread: "Also read shot details from the new file",
    edit_replace_reread_hint: "Off by default — most edits don't change the camera/lens/exposure data.",
    edit_replace_submit: "Replace image",
    edit_replacing: "Replacing…",
    edit_replaced: "Image replaced.",
    edit_saved: "Changes saved.",
    edit_camera_make: "Camera make",
    edit_camera_model: "Camera model",
    edit_lens: "Lens",
    edit_iso: "ISO",
    edit_aperture: "Aperture (e.g. f/2.8)",
    edit_shutter: "Shutter (e.g. 1/250s)",
    edit_focal_length: "Focal length (e.g. 35mm)",
    edit_date_taken: "Date taken",
    edit_exif_lead: "Fill these in if your file didn't include camera metadata, or correct any auto-read values.",
    view_in_english: "View in English",
    view_in_spanish: "Ver en español",
    showing_alt_lang: "Showing the other language. Click again to revert.",
    category: "Category",
    category_optional: "Category (optional)",
    genres: "Genres",
    all_genres: "All genres",
    genres_lead: "Browse by photography genre. 12 hand-picked categories — pick the one that fits your frame.",
    no_photos_in_category: "No photographs in this genre yet.",
    cat_landscape: "Landscape",
    cat_portrait: "Portrait",
    cat_street: "Street",
    cat_wildlife: "Wildlife",
    cat_macro: "Macro",
    cat_still_life: "Still Life",
    cat_product_food: "Product & Food",
    cat_aerial: "Aerial & Drone",
    cat_architecture: "Architecture",
    cat_black_white: "Black & White",
    cat_travel: "Travel",
    cat_night_astro: "Night & Astro",
    cat_nature_flora: "Nature & Flora",
    cat_fine_art: "Fine Art",
    cat_sport_action: "Sport & Action",
    cat_documentary: "Documentary",
    cat_landscape_desc: "Natural scenery, vistas, and the land itself — wide or intimate.",
    cat_portrait_desc: "Faces and figures — formal, candid, or environmental.",
    cat_street_desc: "Daily life and chance moments in public spaces.",
    cat_wildlife_desc: "Animals in their natural habitat — birds, mammals, marine life.",
    cat_macro_desc: "Extreme close-ups revealing what the eye doesn't normally see.",
    cat_still_life_desc: "Composed arrangements of inanimate objects.",
    cat_product_food_desc: "Commercial-style shots of products, dishes, and ingredients.",
    cat_aerial_desc: "Drone, helicopter, or high-vantage perspectives looking down.",
    cat_architecture_desc: "Buildings, structures, and the built environment.",
    cat_black_white_desc: "Monochrome work where tone, contrast, and grain do the talking.",
    cat_travel_desc: "Places, cultures, and journeys — a sense of being somewhere.",
    cat_night_astro_desc: "After-dark scenes, light trails, stars, and the Milky Way.",
    cat_nature_flora_desc: "Plants, flowers, leaves, and botanical detail — the world that doesn't move.",
    cat_fine_art_desc: "Conceptual, painterly, or interpretive work — the photograph as art object.",
    cat_sport_action_desc: "Athletes, motion, competition — anything captured at speed.",
    cat_documentary_desc: "Real events, communities, and social issues told through photography.",
    suggest_category: "Find me a category",
    suggesting: "Analyzing photo…",
    suggested_category: "Suggested: {label}. You can change it.",
    no_suggestion: "Couldn't tell — pick a category below.",
    notif_empty: "No notifications yet.",
    notif_mark_all_read: "Mark all read",
    notif_appreciate: "{name} appreciated your photo",
    notif_comment: "{name} commented on your photo",
    notif_critique: "{name} left a technical critique",
    notif_follow: "{name} started following you",
    notif_pick: "Your photo was named Pick of the Week",
    someone: "Someone",
    just_now: "just now",
    m: "m",
    h: "h",
    d: "d",
  },
  es: {
    brand: "Galería Social",
    tagline: "Una sala silenciosa para fotógrafos.",
    lead:
      "Un feed curado dedicado al trabajo fotográfico. Sin ruido. Sin filtros. Solo imágenes que merecen mirada.",
    global_feed: "Feed Global",
    explore: "Explorar",
    sign_in: "Iniciar sesión",
    sign_up: "Registrarse",
    sign_out: "Cerrar sesión",
    upload: "Subir",
    my_profile: "Mi perfil",
    email: "Correo",
    password: "Contraseña",
    name: "Nombre",
    create_account: "Crear cuenta",
    already_have: "¿Ya tienes cuenta?",
    no_account: "¿Nuevo en Galería Social?",
    by_artist: "Por",
    appreciate: "Apreciar",
    appreciated: "Apreciado",
    comments: "Comentarios",
    critique: "Crítica Técnica",
    write_comment: "Comparte tu impresión…",
    write_critique: "Ofrece una crítica técnica — luz, composición, equipo…",
    post: "Publicar",
    back_to_feed: "Volver al feed",
    shot_details: "Ficha Técnica",
    camera: "Cámara",
    lens: "Objetivo",
    iso: "ISO",
    aperture: "Apertura",
    shutter: "Obturador",
    focal_length: "Distancia focal",
    date_taken: "Fecha",
    resolution: "Resolución",
    no_exif: "No hay datos EXIF para esta imagen.",
    upload_title: "Subir una nueva obra",
    upload_desc:
      "Sube una única fotografía en alta resolución. Los datos EXIF se leen automáticamente.",
    file: "Archivo",
    photo_title: "Título",
    photo_description: "Descripción",
    submit: "Publicar",
    uploading: "Publicando…",
    profile: "Perfil",
    about: "Acerca de",
    works: "Obras",
    no_photos_yet: "Aún no hay fotografías.",
    edit_profile: "Editar perfil",
    save: "Guardar",
    cancel: "Cancelar",
    bio: "Biografía",
    avatar_url: "URL del avatar",
    login_title: "Bienvenido de nuevo.",
    register_title: "Únete a la galería.",
    share: "Compartir",
    share_copied: "Enlace copiado al portapapeles.",
    featured: "Elección de la semana",
    pick_of_week: "Elección de la semana",
    pin_as_pick: "Destacar como Elección de la semana",
    pinned: "Destacado",
    follow: "Seguir",
    following: "Siguiendo",
    followers_label: "Seguidores",
    search_placeholder: "Buscar cámara u objetivo…",
    no_results: "Ninguna imagen coincide con esta cámara.",
    hero_eyebrow: "Est. 2026 — Sociedad fotográfica",
    explore_feed: "Explorar el feed",
    join: "Hazte miembro",
    loading: "Cargando…",
    frames: "fotografías",
    followers: "seguidores",
    members: "Miembros",
    upgrade: "Mejorar",
    upgrade_title: "Únete al círculo Portfolio.",
    upgrade_lead: "Obtén una insignia verificada, una página personalizada /p/{slug} y resolución de subida ilimitada. Un único pago, para siempre.",
    portfolio_tier: "Portfolio — de por vida",
    price: "$4.99",
    price_note: "pago único",
    feature_verified: "Punto rojo verificado junto a tu nombre en cada obra",
    feature_portfolio: "URL personalizada: /p/tu-nombre",
    feature_resolution: "Resolución de subida ilimitada",
    feature_support: "Apoya la galería",
    upgrade_cta: "Mejorar ahora",
    already_premium: "Ya eres miembro Portfolio. ✦",
    upgrade_cancelled: "Compra cancelada — no se realizó ningún cargo.",
    paying: "Redirigiendo al pago seguro…",
    payment_success_title: "Bienvenido a Portfolio.",
    payment_success_body: "Tu insignia verificada está activa y tu página está lista.",
    go_to_portfolio: "Ver mi portafolio",
    payment_failed: "El pago no se completó. Inténtalo de nuevo desde Mejorar.",
    checking_payment: "Confirmando tu pago…",
    verified: "Verificado",
    critique_composition: "Composición",
    critique_exposure: "Exposición y luz",
    critique_processing: "Post-procesado",
    critique_rate: "Valorar",
    critique_notes: "Notas — luz, encuadre, equipo, intención…",
    critique_rating_summary: "Valoración",
    hubs: "Equipo",
    hubs_eyebrow: "Curado · Por equipo",
    hubs_eyebrow_detail: "Hub de equipo",
    hubs_title: "Obras por cámara",
    hubs_lead:
      "Explora el feed desde la mirada de un modelo de cámara. Cada cuerpo usado en Galería Social tiene su propia página curada.",
    hubs_empty: "Aún no hay hubs — sé el primero en subir una imagen con EXIF.",
    frame: "imagen",
    share_to: "Compartir en",
    copy_link: "Copiar enlace",
    share_copy_failed: "No se pudo copiar el enlace.",
    share_instagram_hint: "Enlace copiado — pégalo en Instagram.",
    forgot_password_link: "¿Olvidaste tu contraseña?",
    forgot_title: "¿Olvidaste tu contraseña?",
    forgot_lead: "Ingresa el correo con el que te registraste. Si lo encontramos, te enviaremos un enlace para elegir una nueva contraseña.",
    forgot_submit: "Enviar enlace",
    forgot_sent: "Revisa tu bandeja. Si existe una cuenta con ese correo, recibirás un enlace en breve. El enlace caduca en 60 minutos.",
    reset_title: "Elige una nueva contraseña.",
    reset_lead: "Mínimo 6 caracteres. Iniciarás sesión automáticamente al guardarla.",
    reset_new_password: "Nueva contraseña",
    reset_confirm_password: "Confirmar contraseña",
    reset_submit: "Guardar contraseña",
    reset_invalid_title: "El enlace parece inválido.",
    reset_invalid_body: "Este enlace para restablecer contraseña falta, expiró o ya fue usado. Solicita uno nuevo abajo.",
    password_too_short: "La contraseña debe tener al menos 6 caracteres.",
    password_mismatch: "Las contraseñas no coinciden.",
    darkroom_mode: "Cuarto oscuro",
    darkroom_exit: "Salir del cuarto oscuro",
    darkroom_hint: "Vista inmersiva · presiona Esc para salir",
    darkroom_hide_exif: "Ocultar detalles",
    darkroom_show_exif: "Mostrar detalles",
    backdrop_dark: "Fondo oscuro",
    backdrop_grey: "Fondo gris",
    backdrop_light: "Fondo claro",
    dominant_color: "Color dominante",
    hint_click_to_search: "Toca un dato para encontrar imágenes parecidas",
    filtered_feed: "Feed filtrado",
    clear_all: "Limpiar todo",
    tip_iso: "El ISO mide la sensibilidad del sensor a la luz. Bajo es más limpio; alto permite disparar con poca luz pero añade grano.",
    tip_aperture: "El diafragma (número f) controla la profundidad de campo. Más bajo difumina el fondo; más alto deja más en foco.",
    tip_shutter: "La velocidad de obturación define cuánto ve la luz el sensor. Rápida congela; lenta difumina o capta más luz.",
    tip_focal_length: "La distancia focal es el zoom. Corta = vista amplia; larga = teleobjetivo, comprime las distancias.",
    tip_lens: "El objetivo con el que se hizo la foto. Toca para ver otras imágenes con el mismo lente.",
    partner_eyebrow: "Aliado destacado · Escanea para visitar",
    partner_title: "DSLR Advisor — Inicia sesión",
    welcome_eyebrow: "Una nota del curador",
    welcome_title: "Bienvenido a Galería Social.",
    welcome_p1: "Un espacio dedicado al arte de la fotografía — creado para fotógrafos de todos los niveles para compartir su trabajo, participar en crítica técnica y explorar el oficio sin el ruido de las redes sociales tradicionales.",
    welcome_p2: "Tanto si eres un estudiante dominando los ajustes manuales como un entusiasta experimentado, Galería Social ofrece un entorno limpio para mostrar tu visión y aprender de la comunidad.",
    welcome_p3: "Espero que este espacio te sea útil en tu camino creativo. Tu retroalimentación es esencial mientras seguimos refinando esta plataforma. Si tienes ideas que compartir o necesitas asistencia, no dudes en escribir.",
    contact_eyebrow: "Contacto",
    views: "vistas",
    shares: "compartidos",
    stats_views: "Vistas",
    stats_shares: "Compartidos",
    photo_stats: "Alcance",
    notifications: "Notificaciones",
    edit_photo: "Editar foto",
    edit_photo_title: "Editar tu fotografía",
    edit_section_details: "Detalles",
    edit_section_exif: "Ficha técnica",
    edit_section_replace: "Reemplazar imagen",
    edit_save: "Guardar cambios",
    edit_saving: "Guardando…",
    edit_replace_lead: "Sube una nueva versión de esta imagen. Las vistas, aprecios y comentarios se mantienen.",
    edit_fix_orientation: "Corregir rotación",
    edit_fixing_orientation: "Corrigiendo rotación…",
    edit_fix_orientation_hint: "Regenera la miniatura usando la orientación EXIF. Útil si la miniatura aparece de lado.",
    edit_orientation_fixed: "Rotación corregida.",
    refresh_all_thumbnails: "Corregir rotación en todas mis fotos",
    refreshing_all: "Regenerando miniaturas…",
    refresh_all_done: "Corregidas {fixed} de {total} fotos.",
    tools_organize: "Organizar géneros",
    tools_duplicates: "Buscar duplicados",
    tools_eyebrow: "Herramientas",
    bc_title: "Categorizar en lote",
    bc_sub: "Todas tus fotos sin género, en un solo lugar. Las sugerencias de la IA vienen preseleccionadas. Confírmalas, cámbialas o quítalas y guarda.",
    bc_suggesting: "La IA está mirando…",
    bc_ai_badge: "Sugerencia IA",
    bc_no_suggestion: "Sin sugerencia de la IA. Elige uno.",
    bc_save: "Guardar {n} fotos",
    bc_saved: "Géneros guardados para {n} fotos.",
    bc_empty: "Todas tus fotos tienen género.",
    dup_title: "Limpieza de duplicados",
    dup_sub: "Encuentra subidas que son exactamente el mismo archivo. Por defecto se conserva la copia más antigua de cada grupo.",
    dup_scope_mine: "Mis fotos",
    dup_scope_all: "Todos (admin)",
    dup_scanning: "Analizando… el primer análisis puede tardar hasta un minuto.",
    dup_none: "No se encontraron duplicados en {n} fotos.",
    dup_group: "{n} copias",
    dup_keep: "Conservar",
    dup_delete_mark: "Eliminar",
    dup_delete_selected: "Eliminar {n} seleccionadas",
    dup_confirm_title: "¿Eliminar {n} fotos?",
    dup_confirm_body: "Esto elimina para siempre las fotos seleccionadas junto con sus apreciaciones y comentarios. No se puede deshacer.",
    dup_cancel: "Cancelar",
    dup_deleted: "Eliminadas {n} fotos.",
    dup_uploaded: "Subida",
    email_did_you_mean: "¿Quisiste decir",
    bc_save_one: "Guardar 1 foto",
    bc_saved_one: "Género guardado para 1 foto.",
    dup_delete_selected_one: "Eliminar 1 seleccionada",
    dup_confirm_title_one: "¿Eliminar 1 foto?",
    dup_deleted_one: "Eliminada 1 foto.",
    dup_none_one: "No se encontraron duplicados en 1 foto.",
    edit_replace_file: "Elegir archivo",
    edit_replace_reread: "Leer la ficha técnica del nuevo archivo",
    edit_replace_reread_hint: "Desactivado por defecto — la mayoría de las ediciones no cambian la cámara/objetivo/exposición.",
    edit_replace_submit: "Reemplazar imagen",
    edit_replacing: "Reemplazando…",
    edit_replaced: "Imagen reemplazada.",
    edit_saved: "Cambios guardados.",
    edit_camera_make: "Marca de cámara",
    edit_camera_model: "Modelo de cámara",
    edit_lens: "Objetivo",
    edit_iso: "ISO",
    edit_aperture: "Apertura (ej. f/2.8)",
    edit_shutter: "Obturador (ej. 1/250s)",
    edit_focal_length: "Distancia focal (ej. 35mm)",
    edit_date_taken: "Fecha de toma",
    edit_exif_lead: "Completa estos campos si tu archivo no incluye metadatos, o corrige cualquier valor leído automáticamente.",
    view_in_english: "View in English",
    view_in_spanish: "Ver en español",
    showing_alt_lang: "Mostrando el otro idioma. Toca de nuevo para volver.",
    category: "Categoría",
    category_optional: "Categoría (opcional)",
    genres: "Géneros",
    all_genres: "Todos los géneros",
    genres_lead: "Explora por género fotográfico. 12 categorías escogidas a mano — elige la que mejor describa tu trabajo.",
    no_photos_in_category: "Aún no hay fotografías en este género.",
    cat_landscape: "Paisaje",
    cat_portrait: "Retrato",
    cat_street: "Callejera",
    cat_wildlife: "Vida salvaje",
    cat_macro: "Macro",
    cat_still_life: "Naturaleza muerta",
    cat_product_food: "Producto y comida",
    cat_aerial: "Aérea y dron",
    cat_architecture: "Arquitectura",
    cat_black_white: "Blanco y negro",
    cat_travel: "Viajes",
    cat_night_astro: "Nocturna y astrofotografía",
    cat_nature_flora: "Naturaleza y flora",
    cat_fine_art: "Bellas artes",
    cat_sport_action: "Deporte y acción",
    cat_documentary: "Documental",
    cat_landscape_desc: "Escenarios naturales, paisajes y la tierra misma — amplios o íntimos.",
    cat_portrait_desc: "Rostros y figuras — formales, espontáneos o de entorno.",
    cat_street_desc: "Vida cotidiana y momentos fortuitos en espacios públicos.",
    cat_wildlife_desc: "Animales en su hábitat natural — aves, mamíferos, vida marina.",
    cat_macro_desc: "Primerísimos planos que revelan lo que el ojo no suele ver.",
    cat_still_life_desc: "Composiciones de objetos inanimados.",
    cat_product_food_desc: "Tomas comerciales de productos, platos e ingredientes.",
    cat_aerial_desc: "Drone, helicóptero o vistas elevadas hacia abajo.",
    cat_architecture_desc: "Edificios, estructuras y el entorno construido.",
    cat_black_white_desc: "Monocromo donde el tono, el contraste y el grano cuentan la historia.",
    cat_travel_desc: "Lugares, culturas y viajes — la sensación de estar en algún sitio.",
    cat_night_astro_desc: "Escenas nocturnas, estelas de luz, estrellas y la Vía Láctea.",
    cat_nature_flora_desc: "Plantas, flores, hojas y detalle botánico — el mundo que no se mueve.",
    cat_fine_art_desc: "Trabajo conceptual, pictórico o interpretativo — la foto como objeto artístico.",
    cat_sport_action_desc: "Atletas, movimiento, competición — todo capturado en velocidad.",
    cat_documentary_desc: "Eventos reales, comunidades y temas sociales contados a través de la fotografía.",
    suggest_category: "Sugerir categoría",
    suggesting: "Analizando foto…",
    suggested_category: "Sugerencia: {label}. Puedes cambiarla.",
    no_suggestion: "No pude decidir — elige una categoría abajo.",
    notif_empty: "Aún no hay notificaciones.",
    notif_mark_all_read: "Marcar todo leído",
    notif_appreciate: "{name} apreció tu foto",
    notif_comment: "{name} comentó tu foto",
    notif_critique: "{name} dejó una crítica técnica",
    notif_follow: "{name} comenzó a seguirte",
    notif_pick: "Tu foto fue elegida como Elección de la semana",
    someone: "Alguien",
    just_now: "ahora",
    m: "m",
    h: "h",
    d: "d",
  },
};

export const defaultLang = "en";
